import React from "react";
import { Box, Typography } from "@mui/material";
import type { MedRecent } from "src/providers/compliance/complianceTypes";
import type { ComplianceCheck } from "src/providers/compliance/complianceFilters";
import { CB, checkSwatchLevel } from "./complianceColors";
import { ExemptLight, recencyLabel, TrafficLight } from "./TrafficLight";

interface MedCellProps {
  medRecent: MedRecent;
  // False when there's no medication data to show.
  loaded: boolean;
  // Run with the triage thresholds, so the cell matches triage.
  check: ComplianceCheck;
  exempt: boolean;
  exemptReason: string | null;
  monitoredDays: number;
}

// Fits the widest caption ("No schedule").
const MED_SWATCH_SLOT_WIDTH = 72;

// Recency only for now; adherence will be added to the patient list later.
export function MedCell({
  medRecent,
  loaded,
  check,
  exempt,
  exemptReason,
  monitoredDays
}: MedCellProps): JSX.Element {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
      {/* Fixed width, so the swatch lines up across rows whatever the caption's length */}
      <Box
        sx={{
          width: MED_SWATCH_SLOT_WIDTH,
          flexShrink: 0,
          display: "flex",
          justifyContent: "center"
        }}
      >
        {exempt ? (
          <ExemptLight label="Medication" reason={exemptReason} />
        ) : (
          <TrafficLight
            level={checkSwatchLevel(check)}
            label="Medication"
            caption={
              !loaded
                ? "—"
                : medRecent.hasSchedule
                ? recencyLabel(medRecent.daysSinceLastData, monitoredDays)
                : "No schedule"
            }
            status={
              !loaded
                ? "not available"
                : medRecent.hasSchedule
                ? undefined
                : "no medication schedule"
            }
          />
        )}
      </Box>
      {!exempt && loaded && medRecent.autologOn && (
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 600,
            color: CB.SKY_TEXT,
            lineHeight: 1.2
          }}
        >
          Auto-logging on
        </Typography>
      )}
    </Box>
  );
}
